module.exports = __webpack_public_path__ + "static/media/bitcoin-barcode.745eb7e3.gif";